import { Injectable, inject } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { AuthService } from "../auth/auth.service";

@Injectable({
  providedIn: 'root'
})
export class RedirectAuthenticatedGuard  {
  private readonly authService = inject(AuthService);
  private readonly router = inject(Router);

  canActivate(): UrlTree {
    if (this.authService.authStatus !== 'authenticated') {
      return this.router.createUrlTree(['/login']);
    }

    if (this.authService.can('fullAdmin', 'user')) {
      return this.router.createUrlTree(['/admin/dashboard']);
    }

    if (this.authService.can('adminProjects', 'user')) {
      return this.router.createUrlTree(['/admin/projects']);
    }

    return this.router.createUrlTree(['/projects']);
  }
}
